import React from "react"
import Fade from "react-reveal/Fade"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import Box from "@material-ui/core/Box"
import BannerNav from "../banner-nav"
import { Check2 } from "react-bootstrap-icons"

import bannerLogo from "../../assets/what-you-get-banner.png"

import Markdown from "react-markdown"

const WhatYouGetBanner = props => {
  const { cms } = props
  return (
    <Box
      className="what-you-get-banner"
      component="section"
      display="flex"
      alignItems="center"
    >
      <Container>
        <Grid container>
          <Grid item className="what-you-get-banner__left" xs={12} lg={6}>
            <Box display="flex" flexDirection="column" justifyContent="center">
              <Markdown allowDangerousHtml>{cms.title}</Markdown>
              <ul className="what-you-get-banner__check-list">
                {cms.list.map((element, index) => {
                  return (
                    <li>
                      <Box
                        display="flex"
                        flexDirection="row"
                        alignItems="center"
                      >
                        <Check2 size="48px"></Check2>
                        <Markdown allowDangerousHtml>
                          {element.content}
                        </Markdown>
                      </Box>
                    </li>
                  )
                })}
              </ul>
              <BannerNav
                boxText={cms.link_bar.box_title}
                boxLink={cms.link_bar.box_link}
                boxId="orderLinkButton"
                colorClass="white"
                circularText={cms.link_bar.circular_title}
                circularLink={cms.link_bar.circular_link}
              ></BannerNav>
            </Box>
          </Grid>
          <Grid item className="what-you-get-banner__right" xs={12} lg={6}>
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              height="100%"
            >
              <Fade fraction={0.5}>
                <img src={bannerLogo} alt="Carebits what you get banner"></img>
              </Fade>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  )
}

export default WhatYouGetBanner
